import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';

import useWindowResize from '@source/hooks/useWindowResize';

const StyledContainer = styled.div``;
const StyledWrapper = styled.div`
  display: flex;
  margin-top: 38px;
  width: 100%;
  gap: 16px;
  > div {
    flex: 1;
  }
`;

const StyledSkeletonButtonWrapper = styled.div`
  background: ${(props) => props.theme.color.surfaceLight};
  height: 439px;
  border: 1px solid rgb(237, 237, 237);
  box-shadow: rgb(33 33 33 / 15%) 0px 4px 15px;
  border-radius: 12px;

  .ant-skeleton-button {
    &.image-skeleton {
      height: 193px;
    }
  }
`;

const NUMBER_OF_POPULAR_CARS_SKELETON = 3;
const NUMBER_OF_POPULAR_CARS_MOBILE_SKELETON = 1;

const PopularCarSkeleton = () => {
  const [width] = useWindowResize();
  let numberOfCards = 0;

  if (width && width >= 1280) {
    numberOfCards = NUMBER_OF_POPULAR_CARS_SKELETON;
  } else if (width && width < 1280) {
    numberOfCards = NUMBER_OF_POPULAR_CARS_MOBILE_SKELETON;
  }

  const skeletonCards = Array.from(Array(numberOfCards).keys());

  return (
    <StyledContainer>
      <Skeleton.Input active size="default" />
      <StyledWrapper>
        {skeletonCards.map((item) => (
          <StyledSkeletonButtonWrapper key={item}>
            <Skeleton.Button className="image-skeleton mb-20" size="large" shape="default" block active />
            <Skeleton className="paragraph-skeleton pl-8 pr-8" paragraph={{ rows: 4 }} active />
          </StyledSkeletonButtonWrapper>
        ))}
      </StyledWrapper>
    </StyledContainer>
  );
};

export default PopularCarSkeleton;
